import React from 'react';
import './Header.css';
import { trackEvent } from '../utils/ga.js';

const Header = ({ pageType = 'ko-vn' }) => {
    const handleAdClick = (adName, adUrl) => {
        trackEvent('click_header', {
            ad_name: adName,
            link_url: adUrl,
        });
    };



    return (
        <header className="header">
            <div className="header-container">
            </div>
        </header>
    );
};

export default Header;
